"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _RemindFill = _interopRequireDefault(require("@rsuite/icon-font/lib/status/RemindFill"));

// Generated by script, don't edit it please.
var RemindFill = (0, _createSvgIcon["default"])({
  as: _RemindFill["default"],
  ariaLabel: 'remind fill',
  category: 'status',
  displayName: 'RemindFill'
});
var _default = RemindFill;
exports["default"] = _default;
module.exports = exports.default;